module.exports = __webpack_public_path__ + "static/media/Uk.804d3f66.png";